import React from "react";
import styles from "./Important.module.scss";

import flowers from "./flowers.jpg";
import { Link } from "react-router";

const Important: React.FC = () => {
  return (
    <section className={styles.important}>
      <div className="container">
        <h2 className="title">Важно</h2>
        <div className={styles.body}>
          <div className={styles.image}>
            <img src={flowers} alt="flowers" />
          </div>
          <div className={styles.text}>
            <p>
              При размещении заказа берите в учет время доставки, которое зависит как от удаленности вашего местоположения, так и
              от того, какой способ отправки вы выбрали. <Link to="/">Здесь</Link> вы можете найти детальные сведения об условиях
              доставки.
            </p>
            <p>
              Цена доставки определяется, исходя из расстояния до пункта назначения, варианта отправки и выбора перевозчика,
              размеров и веса товара. В процессе оформления заказа наш менеджер назовет вам приблизительную стоимость, но
              финальная цена будет озвучена только после того, как заказ будет полностью сформирован и упакован.
            </p>
            <p>
              Минимальный размер заказа составляет 1000 рублей. Подготовка товара к отправке начинается после получения
              предоплаты. Отправка производится каждый день после полной оплаты заказа и его доставки.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Important;
